import * as React from 'react';
import { Chips } from '@cian/ui-kit';

import { houseTypeDescriptor } from '../../constants/descriptors';
import { isDescriptorActive } from '../../utils/filters';
import { connectToDescriptors, IDescriptorProps } from '../сonnectToDescriptors';
import { getOffersCount } from '../../actions/offersData';
import { updateTags } from '../../actions/filterTags';
import { TTypedThunkDispatch } from '../../types/thunk';

export interface IHouseTypeProps extends IDescriptorProps<string> {
  getOffersCount(): void;
  updateTags(): void;
}

const HouseTypeComponent: React.FC<IHouseTypeProps> = React.memo(
  ({ actionCreator, getOffersCount, updateTags, jsonQuery, descriptors }) => {
    const options = React.useMemo(
      () =>
        descriptors.map(({ state, label }) => ({
          label,
          value: state,
        })),
      [descriptors],
    );

    const activeDescriptors = descriptors.filter(descriptor => isDescriptorActive(descriptor)(jsonQuery));
    const currentValues = React.useMemo(() => activeDescriptors.map(d => d.state), [activeDescriptors]);

    const handleChipClick = React.useCallback(
      (value: string) => {
        // oxlint-disable-next-line typescript/no-non-null-assertion
        actionCreator(descriptors.find(d => d.state === value)!)();
        updateTags();
        getOffersCount();
      },
      [actionCreator, descriptors, getOffersCount, updateTags],
    );

    return (
      <Chips options={options} size="M" value={currentValues} selectType="multiple" onChipClick={handleChipClick} />
    );
  },
);

HouseTypeComponent.displayName = 'HouseTypeComponent';

function mapDispatchToProps(dispatch: TTypedThunkDispatch) {
  return {
    getOffersCount: () => {
      dispatch(getOffersCount());
    },
    updateTags: () => {
      dispatch(updateTags());
    },
  };
}

export const HouseType = connectToDescriptors(houseTypeDescriptor, mapDispatchToProps)(HouseTypeComponent);
